import React from "react";
import { MessageCircle } from "lucide-react";
import { SITE } from "../data/content";

export default function FloatingWhatsApp() {
    const text = encodeURIComponent(
        "Hi Shreya, I came across Soul Sync Healing and would love to know more.",
    );
    return (
        <a
            href={`https://wa.me/${SITE.whatsappRaw}?text=${text}`}
            target="_blank"
            rel="noreferrer"
            aria-label="Chat with Shreya on WhatsApp"
            data-testid="floating-whatsapp"
            className="fixed bottom-6 left-6 z-40 group flex items-center gap-3 bg-[#A68A6B] hover:bg-[#897157] text-white px-5 h-14 shadow-[0_18px_40px_-20px_rgba(44,43,41,0.45)] transition-colors"
        >
            <MessageCircle className="h-5 w-5" strokeWidth={1.5} />
            <span className="text-xs uppercase tracking-[0.22em] hidden sm:inline">
                Chat on WhatsApp
            </span>
        </a>
    );
}
